export enum USER_SETTINGS_ROUTE_NAMES {
  USER_SETTINGS_INDEX = "user-settings-index",
}
